import {observer} from 'mobx-react';
import {Spinner} from 'shared/components';
import {FormattedMessage} from 'react-intl';
import {FullscreenModal, PreviewBanner} from 'shared/components/modals';
import ScheduleInterviewContainer from './ScheduleInterviewContainer';

const InterviewInvitePreviewModal = observer(({uiState, isOpen, onHide}) => {
  const {scheduleInterviewState} = uiState;

  return (
    <FullscreenModal isOpen={isOpen} onHide={onHide}>
      <PreviewBanner onHide={onHide}>
        <FormattedMessage id='recruiting.schedule_interview.Previewing Candidate View'/>
      </PreviewBanner>
      {scheduleInterviewState.interviewInvite ?
        <ScheduleInterviewContainer preview uiState={scheduleInterviewState}/> :
        <Spinner/>}
    </FullscreenModal>
  );
});

export default InterviewInvitePreviewModal;
